export const FETCH_LOG_LIST_REQUEST = 'FETCH_LOG_LIST_REQUEST'
export const FETCH_LOG_LIST_SUCCESS = 'FETCH_LOG_LIST_SUCCESS'
export const FETCH_LOG_LIST_FALUIRE = 'FETCH_LOG_LIST_FALUIRE'
